import React from 'react'
import Helmet from 'react-helmet'

import { useSiteConfig } from '../utils/SEO'
import { useGetLanguages } from './languages'

const getNewPath = slug => slug.split('/').slice(3).join('/')

const LanguageTags = ({ baseURL, slug, lang }) => {
  const languages = useGetLanguages(slug)

  const { siteUrl } = useSiteConfig()
  const defaultHref = `${siteUrl}/${baseURL}/en/${getNewPath(slug)}`
  return (
    <Helmet>
      <html lang={lang} />
      <link rel="canonical" href={`${siteUrl}${slug}`} />
      <link rel="alternate" hrefLang="x-default" href={defaultHref} />
      {languages.map(langCode => {
        const href = `${siteUrl}/${baseURL}/${langCode}/${getNewPath(slug)}`
        return (
          <link
            rel="alternate"
            hrefLang={langCode}
            href={href}
            key={langCode}
          />
        )
      })}
    </Helmet>
  )
}

export default LanguageTags
